import React from 'react'
import { ChevronRightIcon } from '@heroicons/react/24/solid'
import { WhatsNewCard } from './WhatsNewCard'
import { useQuery } from '@tanstack/react-query'
import { handleGetRequest } from '../../utils/api-handler.util'
import { QueryKeys } from '../../utils/queryKeyGenerator'
import { Link } from 'react-router-dom'
import { Swiper, SwiperSlide } from 'swiper/react'
import { FreeMode } from 'swiper/modules'
import 'swiper/css'
import 'swiper/css/free-mode'

export const WhatsNewSection = () => {
  const { data: newProductData } = useQuery({
    queryKey: QueryKeys.newProducts(),
    queryFn: () => handleGetRequest('/products/retail', { order: 'latest' }),
  })
  const newProducts = newProductData?.data || []

  if (newProducts.length === 0) {
    return null
  }

  return (
    <div className="bg-background py-4 border-b border-dashed border-black/50 main-container">
      <div className="flex justify-between items-center mb-2">
        <h2 className="text-lg font-extrabold text-black">What's New</h2>
        <Link to="/products" aria-label="View all new items">
          <ChevronRightIcon className="h-6 w-6 text-secondary-600" />
        </Link>
      </div>

      <div className="py-4 flex overflow-x-auto gap-x-4 scrollbar-hide">
        {newProducts.map((item) => (
          <WhatsNewCard item={item} key={item.id} />
        ))}
      </div>
    </div>
  )
}
